import * as React from 'react'
import { styled } from 'next-yak'

import * as model from '@owl-nest/models'
import * as api from '@owl-nest/api-client/latest'
import * as layout from '../layout'
import { t } from '@owl-nest/localize'

import * as projectModel from '../../../models/project'

const Wrapper = styled(layout.Notification)``

type MessageProps = {
  project: projectModel.Project
  sender: api.PublicUser
}

export function Message({ project, sender }: MessageProps): React.ReactElement<MessageProps> {
  return (
    <Wrapper avatar={model.image.getUrl(sender.avatar.versions, '128x128')} onClick={goToDiscussion}>
      {t('1 new message')}
    </Wrapper>
  )

  function goToDiscussion(): void {
    window.location.href = `/projects/${project.id}/discussion/#last-message`
  }
}
